module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.e26e5c4f.woff2";